import { gql } from '@apollo/client';

export default class GeneratedChecksSubscription {
    static UPDATED_PAYROLL_PRINTING_STATUS = gql`
        subscription updatedPayrollPrintingStatus($printingRequestId: ID!) {
            updatedPayrollPrintingStatus(printingRequestId: $printingRequestId)
        }
    `;
}
